import React from 'react'

export const Tracking: React.FC = () => {
  return <></>
}
